export default "__VITE_ASSET__XaN74gks__"